'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () {
						return e[k];
					}
				});
			}
		});
	}
	n['default'] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgGoogleIcon = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
  clipPath: "url(#google-icon_svg__a)"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19.761 10.231c0-.68-.055-1.363-.172-2.032h-9.433v3.851h5.402a4.629 4.629 0 0 1-2 3.039v2.498h3.223c1.893-1.741 2.98-4.313 2.98-7.356Z",
  fill: "#4285F4"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.156 20.002c2.697 0 4.972-.886 6.63-2.414l-3.223-2.499c-.897.61-2.054.955-3.403.955-2.609 0-4.82-1.76-5.614-4.126H1.22v2.576a10.001 10.001 0 0 0 8.936 5.508Z",
  fill: "#34A853"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M4.542 11.916a5.99 5.99 0 0 1 0-3.829V5.513H1.22a10.009 10.009 0 0 0 0 8.98l3.322-2.576Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10.156 3.958a5.434 5.434 0 0 1 3.837 1.5l2.855-2.856A9.61 9.61 0 0 0 10.157.001 9.998 9.998 0 0 0 1.22 5.512l3.322 2.576c.79-2.37 3.006-4.13 5.614-4.13Z",
  fill: "#EA4335"
}))), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "google-icon_svg__a"
}, /*#__PURE__*/React__namespace.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));

module.exports = SvgGoogleIcon;
//# sourceMappingURL=google-icon.svg.js.map
